import { APP_DOMAIN } from 'services/constants';
import { parseSubdomainFromHostname } from 'utils/getSubdomain';
import { buildWebOrigin } from 'utils/webOrigin';

/**
 * Validates a post-login returnUrl. Only two shapes are ever followed:
 * - apex (`APP_DOMAIN`) paths — re-targeted to the user's default company subdomain;
 * - `{slug}.{APP_DOMAIN}` URLs where `slug` is a company the user belongs to.
 * Anything else (foreign hosts, subdomains of companies the user is not a member of) is dropped —
 * a stale cross-company returnUrl must never override the login destination.
 */
const resolveSafeReturnTarget = (returnUrl, user) => {
  if (!returnUrl) {
    return null;
  }
  let target;
  try {
    target = new URL(returnUrl, buildWebOrigin());
  } catch {
    return null;
  }
  if (target.hostname === APP_DOMAIN) {
    return { target, subDomain: null };
  }
  const slug = parseSubdomainFromHostname(target.hostname);
  if (!slug || !user?.companies?.some(c => c.subDomain === slug)) {
    return null;
  }
  return { target, subDomain: slug };
};

export default resolveSafeReturnTarget;
